import React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import styled, { css } from "styled-components";
import { AccessGarageState } from "src/components/UserAccount/AccessGarage/state";
import Header from "../shared/GarageHeader";
import GarageKey, { GarageKeyType } from "../shared/GarageKey";
import WaityButton from "../shared/WaityButton";

export const Root = styled("div")`
    padding: 40px 30px 40px 15px;
    text-align: center;

    ${(props) => props.theme.breakpoints.up("desktop")} {
        padding: 40px 85px;
    }
`;

export const Description = styled("div")`
    color: ${(props) => props.theme.palette.grey[100]};
    font-size: 16px;
    line-height: 1.3;
    margin: 20px auto 30px;
    max-width: 400px;
`;

export const StyledSendButton = styled(WaityButton)`
    margin: auto;
    max-width: 500px;
`;

export const ErrorMessage = styled("div")`
    border: 1px solid ${(props) => props.theme.palette.error.main};
    color: ${(props) => props.theme.palette.error.main};
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 32px;
    padding: 0.4em 1.5em;
    text-align: center;
`;

const garageKeyStyles = {
    root: css`
        font-size: 16px;
        margin: 0 auto 44px;

        ${(props) => props.theme.breakpoints.up("tablet")} {
            max-width: 500px;
        }

        ${(props) => props.theme.breakpoints.up("desktop")} {
            display: inline-block;
        }
    `,
};

export interface AccessGarageProps {
    errorMessage: string;
    updateGarageKey: (garageKeyType: GarageKeyType, key: string) => void;
    updateGarageKeyType: (garageKeyType: GarageKeyType) => void;
    requestAccess: () => Promise<boolean>;
    onSuccess: () => void;
}

const AccessGarage = (props: AccessGarageProps & AccessGarageState & WithTranslation) => {
    const { t, updateGarageKeyType, updateGarageKey, garageKey, garageKeyType } = props;
    return (
        <Root>
            <Header text={t("UserAccount.AccessGarage.welcome")} />
            <Description>{t("UserAccount.AccessGarage.description")}</Description>
            {props.errorMessage && <ErrorMessage>{props.errorMessage}</ErrorMessage>}
            <GarageKey
                styles={garageKeyStyles}
                updateKeyType={updateGarageKeyType}
                updateKey={updateGarageKey}
                label={t("UserAccount.AccessGarage.garageKeyLabel")}
                garageKeyType={garageKeyType}
                selectedGarageKey={garageKey[garageKeyType]}
            />
            <StyledSendButton
                text={t("UserAccount.AccessGarage.sendButtonLabel")}
                onClick={props.requestAccess}
                onSuccess={props.onSuccess}
            />
        </Root>
    );
};

export default withTranslation()(AccessGarage);
